
import React from 'react';

class QuizBlockChoose extends React.Component {

    constructor(props) {
        super(props);
        this.state = { };

    }
    componentDidMount() { }
    render() {

        return (
            <div>
<br/>

                <h2> { this.props.title } </h2>
                <br/>
                <br/>
                <div className={'d-grid gap-2 col-5 mx-auto'}>
                    <button  onClick={()=>{ this.props.customCallback( "1" )   }} className={'btn btn-default btnChoose'} > { this.props.choose1 } </button>
                    <button  onClick={()=>{ this.props.customCallback( "2" )  }}  className={'btn btn-default btnChoose'} > { this.props.choose2 } </button>
                    <button  onClick={()=>{ this.props.customCallback( "3" )  }}  className={'btn btn-default btnChoose'} > { this.props.choose3 } </button>
                </div>

            </div>
        );
    }
}

export default QuizBlockChoose;